import { useEffect, useState } from "react";
import { Container, Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import "react-image-gallery/styles/css/image-gallery.css";
import "react-rater/lib/react-rater.css";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { getValByLang, checkScreenLaptop } from "../../../utils/helpers";
import MainPage from "./MainPage/MainPage";
import SideBarStore from "./SideBarStore";
import ProductStore from "./ProductStore";
import { useParams } from "react-router-dom";
import { setCategorySelected, setCategorySelectedWithoutReset } from "../../../services/store/storeSlice";
import { useDispatch } from "react-redux";
import { ArrowCircleLeftOutlined as ArrowCircleLeftOutlinedIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
//   const {slug} = useParams();

export default function SearchPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [categoryPageData, setCategoryPageData] = useState(null);
    const { language } = useSelector((state) => state.global);
    const {
        search_term,
        isLoading,
        attributesAvailable,
        categoriesAvailable,
        
        
    } = useSelector((state) => state.store);
    const { screenWidth, mediumWidthScreen } = useSelector(
        (state) => state.global
    );
    const { term } = useParams();


    


    useEffect(() => {
        if (
            typeof window !== "undefined" &&
            !isLoading
        ) {
            window.prerenderReady = true;
        }
    }, [isLoading]);

    return (
        <>
            <Box>
                <Container className="no-padding page_size">
                    {/* Show category page title/description if available */}
                    {/* <Container className="no-padding page_size d-flex " sx={{ display: "flex",justifyContent: "start", alignItems: "center" }}>
                        <Button onClick={() => { navigate('/') }}>
                            <ArrowCircleLeftOutlinedIcon className="back-to-home" />
                        </Button>
                    </Container> */}

                    <Grid container>
                        {checkScreenLaptop(screenWidth, mediumWidthScreen) ? (
                            <>
                                <Grid size={{ lg: 2, md: 4, sm: 4, xs: 6 }}>
                                    <SideBarStore
                                        className="store_sidebar"
                                        isLoading={isLoading}
                                        attributesAvailable={attributesAvailable}
                                        categoriesAvailable={categoriesAvailable}
                                    />
                                </Grid>
                                <Grid size={{ lg: 10, md: 8, sm: 8, xs: 6 }}>
                                    <ProductStore />
                                </Grid>
                            </>
                        ) : (
                            <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                                <ProductStore />
                            </Grid>
                        )}
                    </Grid>
                </Container>
            </Box>
        </>
    );
}